import { render, staticRenderFns } from "./AddPricesCSV.vue?vue&type=template&id=312bf5f1&scoped=true&"
import script from "./AddPricesCSV.vue?vue&type=script&lang=js&"
export * from "./AddPricesCSV.vue?vue&type=script&lang=js&"
import style0 from "./AddPricesCSV.vue?vue&type=style&index=0&id=312bf5f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312bf5f1",
  null
  
)

export default component.exports